import { useMsal } from '@azure/msal-react'
import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Loader from '../components/general/Loader'
import CustomButton from '../components/v2/general/CustomButton/CustomButton'

function Error() {
	const { inProgress } = useMsal()
	const navigate = useNavigate()

	if (inProgress === 'startup' || inProgress === 'handleRedirect') {
		return (
			<Box
				component={'div'}
				style={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
			>
				<Loader />
			</Box>
		)
	}

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100vh' }}>
			<Box sx={{ display: 'flex', flexDirection: 'column' }}>
				<Box sx={{ display: 'flex', justifyContent: 'center' }}>
					<Typography
						variant='h2'
						sx={{ color: 'var(--primary-dark)', fontFamily: 'var(--font-family)' }}
					>
						Erro 404
					</Typography>
				</Box>
				<Box sx={{ display: 'flex', justifyContent: 'center', marginBlockStart: '1rem', marginInline: '10%' }}>
					<Typography
						variant='h5'
						textAlign={'center'}
						sx={{ color: 'var(--primary-dark)', fontFamily: 'var(--font-family)' }}
					>
						Houve um problema no carregamento da página, estamos a resolver com a maior brevidade.
					</Typography>
				</Box>
				<Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
					<CustomButton
						size='large'
						variant='contained'
						color='secondary'
						onClick={() => navigate(-1)}
						sx={{ fontFamily: 'var(--font-family)' }}
					>
						Regressar
					</CustomButton>
				</Box>
			</Box>
		</Box>
	)
}

export default Error
